import { render, staticRenderFns } from "./NavigationBottom.vue?vue&type=template&id=49b50eec&"
import script from "./NavigationBottom.vue?vue&type=script&lang=ts&"
export * from "./NavigationBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNav } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBottomNav,VBtn,VIcon})
